import moment from "moment"

export const formatToStr = (timestamp,dateFormat) => {
  if (dateFormat) {
    return moment(timestamp).format(dateFormat)
  }
  return moment(timestamp).format('YYYY-MM-DD')
}